import { ACCEPTED_FILE_UPLOAD_FORMATS } from 'src/front/common/constants/files';

import { displayDocument } from './domUtils';

export const getMimetype = (fileSignature: string): string => {
  switch (fileSignature) {
    case '25504446':
      return 'application/pdf';
    case 'FFD8FFEE':
      return 'image/jpg';
    case 'FFD8FFDB':
    case 'FFD8FFE0':
    case 'FFD8FFE1':
      return 'image/jpeg';
    case '89504E47':
      return 'image/png';
    case 'D0CF11E0':
      return 'application/msword';
    case '504B0304':
    case '504B0506':
    case '504B0708':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

    default:
      return 'Unknown filetype';
  }
};

export const openDocument = async (files?: FileList | null): Promise<void> => {
  if (!files) {
    return;
  }
  displayDocument(files[0]);
};

export const getFileType = (file: File | Blob): Promise<string> => {
  return new Promise((resolve) => {
    const filereader = new FileReader();
    let fileType = '';

    filereader.onloadend = (evt: ProgressEvent<FileReader>): void => {
      if (evt.target?.readyState === FileReader.DONE) {
        const uint = new Uint8Array(evt.target?.result as ArrayBuffer);
        const bytes: string[] = [];
        uint.forEach((byte) => {
          bytes.push(byte < 10 ? `0${byte.toString(16)}` : byte.toString(16));
        });
        const hex = bytes.join('').toUpperCase();

        fileType = getMimetype(hex);
        resolve(fileType);
      }
    };

    const fileSlice = file?.slice(0, 4);

    fileSlice && filereader.readAsArrayBuffer(fileSlice);
  });
};

export const checkAcceptedFileType = async (files?: FileList | null): Promise<boolean> => {
  if (!files) {
    return false;
  }
  const fileType = await getFileType(files[0]);
  if (ACCEPTED_FILE_UPLOAD_FORMATS.includes(fileType)) {
    return true;
  }
  return false;
};
